import React, {Component} from "react";
import {injectIntl} from "react-intl";
import {connect} from 'react-redux';
import PictureGallery from './picture/PictureGallery'

import "./AttachmentsCard.css";
import LoadingIndicator from "../common/loading/LoadingIndicator";
import {Upload} from "antd";
import Documents from "./attachments/Documents";
import BoxFooter from "./BoxFooter";
import Card from "../common/Card";
import {SpinnerModal} from "../../public/components/SpinnerModal";

class AttachmentsCard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      fileList: []
    }
  }

  componentWillMount(){
    const {uuid, connectedUserId} = this.props;
    if (uuid) {
      this.props.dispatchFetchJourneyComment({uuid, connectedUserId})
    }
  }

  handlePhotoClick = (e)=>{
    this.setState({modal:{visible:true, src:e.target.src}});
  };

  handlePhotoClose = (e)=>{
    this.setState({modal:{visible:false, src:undefined}});
  };

  handleDeletePhoto = (attachment) => {
    const {uuid, connectedUserId} = this.props;
    const {key} = attachment;
    this.props.dispatchDeleteJourneyComment({uuid, connectedUserId, key});
  };

  handleOnDocumentChange = (info) => {
    const {intervention, intervention: {journey}} = this.props;
    const {file, fileList} = info;
    const lastElement = fileList[fileList.length-1];

    // if the current file is the last element of the list, then all files have been loaded
    if (file.uid === lastElement.uid) {
      const form = new FormData();
      fileList.forEach(file => form.append("documents", file));
      form.append("uuid", journey.uuid);
      this.props.dispatchSaveJourneyDocuments(form);
      this.setState({fileList: []});
    }
  };

  handleDocumentBeforeUpload = (file) => {
    const {fileList = []} = this.state;
    fileList.push(file);
    this.setState({fileList});
    return false;
  };

  render() {
    const {intl:{formatMessage}, canWrite} = this.props;
    const {intervention: {journeyComment, customer, journey}, loading} = this.props;

    return (
      <Card
        title={formatMessage({id:'appointment.detail.attachments.title'})}
        footer={canWrite &&
          <BoxFooter>
            <Upload className={"attachment-upload"} style={{width:'100%'}} showUploadList={false} multiple={true} accept=".pdf"
                    fileList={this.state.fileList}
                    onChange={this.handleOnDocumentChange}
                    beforeUpload={this.handleDocumentBeforeUpload}>
              <button type="button" className="btn btn-sm btn-primary">{formatMessage({id: 'appointment.detail.attachments.add-documents'})}</button>
            </Upload>
          </BoxFooter>}
      >
          <SpinnerModal visible={loading}/>
          <div className="row">
            <div className="col-md-4">
              <h3 className="box__subtitle">
                {formatMessage({id:'appointment.detail.attachments.customer-photos.title'})}
              </h3>

              {journeyComment &&
                <ul className="photos-gallery">
                  {!journeyComment.attachments
                    ? <li key="none"><LoadingIndicator/></li>
                    : <PictureGallery pictures={journeyComment.attachments} allowDelete={canWrite} onDelete={this.handleDeletePhoto}/>
                  }
                </ul>
              }
            </div>

            <div className="col-md4">
              {/* DEALER PHOTOS */}
            </div>

            <div className="col-md4">
              <h3 className="box__subtitle">
                {formatMessage({id:'appointment.detail.attachments.dealer-documents.title'})}
              </h3>
              <Documents uuid={journey.uuid} connectedUserId={customer.id} canWrite={canWrite}/>
            </div>
          </div>

          {journeyComment &&
            <div className="row">
              <div className="col-12">
                <h3 className="box__subtitle">
                  {formatMessage({id: 'appointment.detail.attachments.customer-comment.title'})}
                </h3>

                <div className="col-12">
                  <div className="box__body appointment-messages">{journeyComment.comment}</div>
                </div>
              </div>
            </div>
          }

      </Card>
    );
  }
}

const mapStateToProps = state => ({
  intervention: state.fetchIntervention.intervention || {},
  loading: state.fetchIntervention && state.fetchIntervention.loading,
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchJourneyComment: (params) => dispatch({type: 'FETCH.JOURNEY_COMMENT.REQUEST', ...params}),
  dispatchDeleteJourneyComment: (params) => dispatch({type: 'DELETE.JOURNEY_COMMENT.REQUEST', ...params}),
  dispatchSaveJourneyDocuments: (body) => dispatch({type: 'SAVE.JOURNEY_DOCUMENTS.REQUEST', body})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(AttachmentsCard));



// WEBPACK FOOTER //
// ./src/components/interventiondetail/AttachmentsCard.js